import {Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";

@Component({
    selector: 'db-progress-spinner',
    templateUrl: './progress-spinner.component.html',
    styleUrls: ['./progress-spinner.component.scss'],
    standalone: false
})
export class ProgressSpinnerComponent implements OnInit, OnChanges {

  @Input() size: number;
  @Input() strokeWidth: number;
  @Input() type?: 'info'|'success'|'warning'|'danger';
  @Input() progressPercent: number;
  @Input() showPercent?: boolean = true;

  public leftMaskRotation: number;
  public rightMaskRotation: number;

  ngOnInit(): void {
    this.size = this.size || 50;
    this.strokeWidth = this.strokeWidth || 2;
    this.type = this.type || 'info';
    this.progressPercent = this.progressPercent || 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['progressPercent']) {
      this.updateMaskRotations();
    }
  }

  private updateMaskRotations(): void {
    this.rightMaskRotation = Math.min(360 * this.progressPercent / 100, 180);
    this.leftMaskRotation = Math.max(180, 360 * this.progressPercent / 100) - 180;
  }

}
